import { buyerDisputeInit, buyerRatingInit } from "./buyerDisputeAndRating";
import { listingPayoutInit } from "./listingPayout";
import { listingQRImagesInit } from "./listingQRImages";
import { modalsInit } from "./modals";
import { sellerHomeInit, sellerSettingsInit } from "./sellerHomeAndSettings";
import { sellerListingsInit } from "./sellerListings";
import { sellerListingFormInit } from "./sellerListingForm";
import { sellerSearchInit } from "./sellerSearch";
import { btnUtils, makeToast, simulateClick } from "./utils";
import type { RecDropzoneFiles, RecDropzoneFilesCompressed } from "./types";

/* Some helpful global vars */
var recPageActive = "",
  dropzoneObjects: Dropzone[] = [],
  recDropzoneFiles: RecDropzoneFiles = {},
  recDropzonePreloaded: Record<string, string> = {},
  recDropzoneFilesCompressed: RecDropzoneFilesCompressed = {};

/* Define our possible paths */
recAppProxyConfig.paths = {
  pathPrimary: `${recAppProxyConfig.settings.shop.app_proxy_path}?rp`,
  pathListings: `${recAppProxyConfig.settings.shop.app_proxy_path}/listings?rp`,
  pathListingPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/?rp`,
  pathListingPatch: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%?rp`,
  pathListingConfirmation: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/confirm?rp`,
  pathListingPausePost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/pause/?rp`,
  pathListingResumePost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/resume/?rp`,
  pathListingCancelPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/cancel/?rp`,
  pathRatingExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/rating/?rp`,
  pathDisputeExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/dispute/?rp`,
  pathPayoutExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing/%lid%/payout/%selection%/%aid%?rp`,
  pathDraftPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/draft/?rp`,
  pathDraftPatch: `${recAppProxyConfig.settings.shop.app_proxy_path}/draft/%lid%?rp`,
  pathSearchExec: `${recAppProxyConfig.settings.shop.app_proxy_path}/search/?rp`,
  pathPriceRecommendation: `${recAppProxyConfig.settings.shop.app_proxy_path}/price/?rp`,
  pathProductVariants: `${recAppProxyConfig.settings.shop.app_proxy_path}/products/%pid%/variants?rp`,
  pathStripeAidPost: `${recAppProxyConfig.settings.shop.app_proxy_path}/stripe/%country%?rp`,
  pathStripeDashboardGet: `${recAppProxyConfig.settings.shop.app_proxy_path}/stripe/%aid%/link?rp`,
  pathStripeDashboardGetDetails: `${recAppProxyConfig.settings.shop.app_proxy_path}/stripe/%aid%/link/details?rp`,
  pathAddressVerify: `${recAppProxyConfig.settings.shop.app_proxy_path}/address/verify?rp`,
  pathQRListingImages: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing-images-pub/%sid%?rp`,
  pathQRListingImagesCheck: `${recAppProxyConfig.settings.shop.app_proxy_path}/listing-images-check/%sid%?rp`,
  pathAddressGet: `${recAppProxyConfig.settings.shop.app_proxy_path}/address/%aid%?rp`,
  pathAddressSave: `${recAppProxyConfig.settings.shop.app_proxy_path}/address/%aid%?rp`,
};

/* Retrieve active page and URL params */
const queryString = new URLSearchParams(document.location.search);
const recPage = document.querySelector(".rec-page");
if (recPage) {
  const activePage = recPage.getAttribute("data-active-page");
  if (activePage !== null) {
    recPageActive = activePage;
  } else {
    console.error(
      "Error: data-active-page attribute is missing on .rec-page element.",
    );
  }
} else {
  console.error("Error: .rec-page element not found.");
}

/* "button" role spacebar clicks */
document
  .querySelectorAll(`#rec-outer-wrap div[role="button"]`)
  .forEach((thisBtn) => {
    thisBtn.addEventListener("keydown", (e) => {
      const keyboardEvent = e as KeyboardEvent;
      if (keyboardEvent.key === " ") {
        // Check for the spacebar key
        keyboardEvent.preventDefault();
        simulateClick(keyboardEvent.currentTarget as HTMLButtonElement);
      }
    });
  });

document.querySelectorAll(".rec-toast-close").forEach((thisToastClosure) => {
  thisToastClosure.addEventListener("click", (e) => {
    e.preventDefault();
    const target = e.target as HTMLSpanElement;
    const closestToast = target.closest(".rec-toast");
    if (closestToast) {
      closestToast.classList.add("rec-hidden");
    }
  });
});

const listingPreloginConfirm = document.querySelector("#rec-prelogin-confirm");

if (listingPreloginConfirm) {

  const preloginListingId = queryString.get('preloginListingId');
  const preloginSellerUUID = queryString.get('preloginSellerUUID');

  if (preloginListingId && preloginSellerUUID) {
    localStorage.setItem('trove_preloginListingId', preloginListingId);
    localStorage.setItem('trove_preloginSellerUUID', preloginSellerUUID);
  }

  listingPreloginConfirm.addEventListener("click", async (e) => {
    e.preventDefault();
    // START if btnUtils.loadingToggle gets updated to use classList.add instead of classList.toggle replace this block below
    if (e.target !== null) {
      const buttonElement = e.target as HTMLButtonElement;
      buttonElement.setAttribute("data-default-text", buttonElement.innerHTML);
      buttonElement.innerHTML = `<div class="rec-flex rec-justify-center rec-items-center">
                <?xml version="1.0" ?><svg class="rec-animate-spin" fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 10.4142 3.16421 10.75 2.75 10.75C2.33579 10.75 2 10.4142 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C9.58579 18 9.25 17.6642 9.25 17.25C9.25 16.8358 9.58579 16.5 10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5Z" fill="#212121"/></svg>
                </div>`;
      buttonElement.classList.add("rec-is-loading");
      buttonElement.classList.add("disabled");
      buttonElement.disabled = true;
    } else {
      console.error("listingPreloginConfirm: button element is null");
      return;
    }
    // END
    try {
      const customerLoginForm: HTMLFormElement | null =
        document.querySelector("#customer_login");
      if (customerLoginForm !== null) {
        // @ts-expect-error: This file will only load in a Shopify page
        if (window.Shopify?.captcha) {
          // @ts-expect-error: This file will only load in a Shopify page
          window.Shopify?.captcha?.protect(customerLoginForm, () => {
            customerLoginForm.submit();
          });
        } else {
          customerLoginForm.submit();
        }
      }
    } catch (error) {
      console.error("listingPreloginConfirm: ", error);
      makeToast("toast-ajax-error");
      btnUtils.reset();
    }
  });
}

/* Logic to replace the display of an element based on its condition value */
const conditionDisplayInit = () => {
  document
    .querySelectorAll(".rec-condition-display")
    .forEach((thisConditionDisplayElem) => {
      const conditionValue =
        thisConditionDisplayElem.getAttribute("data-rec-condition");
      if (conditionValue !== null) {
        const conditionIndex = parseInt(conditionValue);
        if (
          !isNaN(conditionIndex) &&
          recAppProxyConfig.settings.conditionsLang.length >= conditionIndex
        ) {
          thisConditionDisplayElem.innerHTML =
            recAppProxyConfig.settings.conditionsLang[conditionIndex - 1];
        }
      }
    });
};

/* On Load Toast Features */
const onLoadToasts = () => {
  if (queryString.has("t")) {
    const toastElem = document.querySelector(
      `[data-toast="${queryString.get("t")}"]`,
    );
    if (toastElem) {
      makeToast(toastElem.id);
    }
  }
};

//Setup JS for home page
if (recPageActive == "home") {
  sellerHomeInit();

  //Setup JS for listings page
} else if (recPageActive == "listings") {
  sellerListingsInit(queryString);

  //Setup JS for search page
} else if (recPageActive == "search") {
  sellerSearchInit();
}

//Setup JS for listing form
else if (recPageActive == "list" || recPageActive == "listing") {
  sellerListingFormInit(
    dropzoneObjects,
    recDropzoneFiles,
    recDropzoneFilesCompressed,
    recDropzonePreloaded,
  );
}

//Setup JS for settings screen
else if (recPageActive == "settings") {
  sellerSettingsInit();
}

//Setup JS for ratings screen
else if (recPageActive == "rating") {
  buyerRatingInit();
}

//Setup JS for dispute screen
else if (recPageActive == "dispute") {
  buyerDisputeInit(
    dropzoneObjects,
    recDropzoneFiles,
    recDropzoneFilesCompressed,
    recDropzonePreloaded,
  );
}

//Setup JS for QR listing images
else if (recPageActive == "listing-qr-images") {
  listingQRImagesInit(
    dropzoneObjects,
    recDropzoneFiles,
    recDropzoneFilesCompressed,
    recDropzonePreloaded,
  );
}

//Setup JS for listing payouts
else if (recPageActive == "payout") {
  listingPayoutInit(
    recAppProxyConfig.settings.payout.cash,
    recAppProxyConfig.customer.stripe.aid,
  );
}

//display a specific toast based on what's in the query string
onLoadToasts();

//setup modals
modalsInit();

//setup global replacements of condition
conditionDisplayInit();